import { BaseSelect as BaseSelectComponent } from './BaseSelect';
import { components } from './components';
export var BaseSelect = Object.assign(BaseSelectComponent, components);
export * from './hooks';
//# sourceMappingURL=index.js.map